type PropTypes = {
  className?: string
}

const BackArrowIcon = ({ className }: PropTypes) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="16"
        height="16"
        fill="white"
        fillOpacity={0.01}
        style={{ mixBlendMode: 'multiply' }}
      />
      <path d="M7 13L7.705 12.295L3.915 8.5H14V7.5H3.915L7.705 3.705L7 3L2 8L7 13Z" fill="currentColor" />
    </svg>
  )
}

export default BackArrowIcon
